import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import './SupportCenter.scss'
import { SupportCenterAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import SupportCenterBox from '../../../common/components/SupportCenterBox'
import { useParams } from 'react-router-dom'

const SupportCenterContainer = styled.div`
  padding: 120px !important;
  background: rgb(248, 248, 248);

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px !important;
  }
`

const Title = styled.h1`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  color: rgb(94, 81, 77);
`

const Description = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: rgb(94, 81, 77);
`

const InputTextWrapper = styled.div`
  box-shadow: rgb(0 0 0 / 5%) 0px -1px 2px, rgb(0 0 0 / 10%) 0px 2px 4px;
  border-radius: 6px;
  background-color: rgb(255, 255, 255) !important;
`

const InputTextIcon = styled.div`
  border-right: 0px !important;
  background-color: rgb(255, 255, 255) !important;
`

const InputText = styled.input`
  margin-bottom: 0px;
  border-radius: 0px !important;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 0px;
  border-left: 0px !important;
  font-size: 14px !important;
  border-radius: 0px 6px 6px 0px !important;
  background-color: rgb(255, 255, 255) !important;
`

const ButtonWrapper = styled.div`
  @media screen and (min-width: 767px) {
    width: 20%;
  }
`

const Button = styled.button`
  line-height: 48px;
  border-radius: 0px 6px 6px 0px !important;
  width: 100%;
  font-size: 14px !important;
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const SupportCenter = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    // setisLoading(true);
    loadData()
  }, [])

  const loadData = async function () {
    const { data } = await SupportCenterAPI('')
    if (data?.data) {
      setdata(data.data)
    }

    setisLoading(false)
  }

  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <SupportCenterContainer className="container-fluid">
        <Title>{t('layanan_pengaduan')}</Title>
        <Description>{data.description || ''}</Description>
        <div className="row">
          {data
            .filter((value) => {
              if (
                value?.judul
                  .toString()
                  .toLowerCase()
                  .includes(search.toLocaleLowerCase())
              ) {
                return value
              }
            })
            .map((item) => (
              <div className="col-lg-4 mt-4">
                <Desktop>
                  <SupportCenterBox
                    title={item.judul}
                    info={item.kontak}
                    image={item.imageIconDesktop}
                  />
                </Desktop>
                <Mobile>
                  <SupportCenterBox
                    title={item.judul}
                    info={item.kontak}
                    image={item.imageIconMobile}
                  />
                </Mobile>
              </div>
            ))}
        </div>
      </SupportCenterContainer>

      <FooterSection currentPage={t('layanan_pengaduan')} />
    </div>
  )
}

export default SupportCenter
